import { Control, Controller, FieldValues, Path, PathValue } from "react-hook-form";
import { CustomTextarea, CustomTextareaProps, LabelStyle } from "./custom-textarea";
import { useTranslateMessage } from "@/hooks/useTranslateMessage";

interface ControlledCustomTextareaProps<T extends FieldValues>
  extends Omit<CustomTextareaProps, "value" | "onChange" | "error" | "id"> {
  name: Path<T>;
  control: Control<T>;
  defaultValue?: PathValue<T, Path<T>>;
}

export const ControlledCustomTextarea = <T extends FieldValues>({
  control,
  name,
  defaultValue,
  ...textareaProps
}: ControlledCustomTextareaProps<T>) => {
  const translateMessage = useTranslateMessage();
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => (
        <CustomTextarea
          {...textareaProps}
          id={name}
          value={field.value}
          onChange={field.onChange}
          ref={field.ref}
          error={translateMessage(error?.message)}
        />
      )}
    />
  );
};

export type { LabelStyle };
